import maximorIcon from 'assets/brand/logo_3d.png';
import adpIcon from 'assets/icons/brands/adp.jpg';
import agilysysIcon from 'assets/icons/brands/agilysys.png';
import anrokIcon from 'assets/icons/brands/anrok.png';
import avalaraIcon from 'assets/icons/brands/avalara.png';
import billIcon from 'assets/icons/brands/bill.svg';
import brexIcon from 'assets/icons/brands/brex.svg';
import chargebeeIcon from 'assets/icons/brands/chargebee.png';
import divvyIcon from 'assets/icons/brands/divvy.svg';
import expensifyIcon from 'assets/icons/brands/expensify.svg';
import fourthIcon from 'assets/icons/brands/fourth.svg';
import googleDriveIcon from 'assets/icons/brands/googledrive.svg';
import gustoIcon from 'assets/icons/brands/gusto.png';
import hubspotIcon from 'assets/icons/brands/hubspot.svg';
import insperityIcon from 'assets/icons/brands/insperity.png';
import iplicitIcon from 'assets/icons/brands/iplicit.png';
import maxioIcon from 'assets/icons/brands/maxio.png';
import metronomeIcon from 'assets/icons/brands/metronome.png';
import microsIcon from 'assets/icons/brands/micros.svg';
import netsuiteIcon from 'assets/icons/brands/netsuite.svg';
import openTableIcon from 'assets/icons/brands/open-table.png';
import plaidIcon from 'assets/icons/brands/plaid.svg';
import quickbooksIcon from 'assets/icons/brands/quickbooks.svg';
import rampIcon from 'assets/icons/brands/ramp.svg';
import ripplingIcon from 'assets/icons/brands/rippling.svg';
import sageIntacctIcon from 'assets/icons/brands/sage-intacct.png';
import salesforceIcon from 'assets/icons/brands/salesforce.png';
import sevenRoomsIcon from 'assets/icons/brands/seven-rooms.svg';
import stripeIcon from 'assets/icons/brands/stripe.png';
import orbIcon from 'assets/icons/brands/withorb.png';
import zohobooksIcon from 'assets/icons/brands/zohobooks.svg';

export const spendIntegrations = [
  {
    name: 'Expensify',
    icon: expensifyIcon,
    lastSync: '2 hours ago',
    platform: 'EXPENSIFY',
    isConnected: 'not_connected',
    description:
      "Expensify is a cloud-based expense management software that helps you manage your finances, invoices, and expenses. It's easy to use and integrates seamlessly with your business needs.",
  },
  {
    name: 'Bill',
    icon: billIcon,
    lastSync: '2 hours ago',
    platform: 'BILL',
    isConnected: 'not_connected',
    description:
      "Bill is a cloud-based expense management software that helps you manage your finances, invoices, and expenses. It's easy to use and integrates seamlessly with your business needs.",
  },
  {
    name: 'Brex',
    icon: brexIcon,
    lastSync: '2 hours ago',
    isConnected: 'not_connected',
    description:
      "Brex is a cloud-based expense management software that helps you manage your finances, invoices, and expenses. It's easy to use and integrates seamlessly with your business needs.",
    platform: 'BREX',
  },
  {
    name: 'Ramp',
    icon: rampIcon,
    lastSync: '2 hours ago',
    platform: 'RAMP',
    isConnected: 'not_connected',
    description:
      "Ramp is a cloud-based expense management software that helps you manage your finances, invoices, and expenses. It's easy to use and integrates seamlessly with your business needs.",
  },
  {
    name: 'Divvy',
    icon: divvyIcon,
    lastSync: '2 hours ago',
    platform: 'DIVVY',
    isConnected: 'not_connected',
    description:
      "Divvy is a cloud-based expense management software that helps you manage your finances, invoices, and expenses. It's easy to use and integrates seamlessly with your business needs.",
  },
];

export const PLATFORM_CONSTANTS = {
  QUICKBOOKS_RUTTER: 'QUICKBOOKS_RUTTER',
  QUICKBOOKS_FIVETRAN: 'QUICKBOOKS_FIVETRAN',
  NETSUITE_RUTTER: 'NETSUITE_RUTTER',
  NETSUITE_SUITEANALYTICS_FIVETRAN: 'NETSUITE_SUITEANALYTICS_FIVETRAN',
  SAGE_INTACCT: 'SAGE_INTACCT',
  SAGE_INTACCT_RUTTER: 'SAGE_INTACCT_RUTTER',
  ZOHO_BOOKS: 'ZOHO_BOOKS',
  GOOGLE_DRIVE: 'GOOGLE_DRIVE',

  // Billing integrations
  CHARGEBEE: 'CHARGEBEE_RUTTER',
} as const;

export const accountingIntegrationsData = [
  {
    name: 'QuickBooks (Rutter)',
    icon: quickbooksIcon,
    lastSync: '2 hours ago',
    platform: PLATFORM_CONSTANTS.QUICKBOOKS_RUTTER,
    isConnected: 'not_connected',
    type: 'accounting',
    description: 'Connect QuickBooks via Rutter for unified accounting access.',
  },
  {
    name: 'QuickBooks (Fivetran)',
    icon: quickbooksIcon,
    lastSync: '2 hours ago',
    platform: PLATFORM_CONSTANTS.QUICKBOOKS_FIVETRAN,
    isConnected: 'not_connected',
    type: 'accounting',
    description:
      'Sync QuickBooks data using automated Fivetran pipeline integration.',
  },
  {
    name: 'Netsuite',
    icon: netsuiteIcon,
    lastSync: '3 hours ago',
    platform: PLATFORM_CONSTANTS.NETSUITE_RUTTER,
    isConnected: 'not_connected',
    type: 'accounting',
    description:
      'Integrate NetSuite through Rutter for complete ERP data access.',
  },
  {
    name: 'Zoho Books',
    icon: zohobooksIcon,
    lastSync: '1 hour ago',
    platform: PLATFORM_CONSTANTS.ZOHO_BOOKS,
    isConnected: 'not_connected',
    type: 'accounting',
    description: 'Manage invoices, expenses, and reports with Zoho Books.',
  },
  {
    name: 'Sage Intacct',
    icon: sageIntacctIcon,
    lastSync: '3 hours ago',
    platform: PLATFORM_CONSTANTS.SAGE_INTACCT_RUTTER,
    isConnected: 'not_connected',
    type: 'accounting',
    description:
      'Connect Sage Intacct for advanced financial management and reporting.',
  },
];

export const billingIntegrationsData = [
  {
    platform: PLATFORM_CONSTANTS.CHARGEBEE,
    name: 'Chargebee',
    icon: chargebeeIcon,
    type: 'billing',
    description:
      'Automate billing and subscription management using Chargebee platform.',
  },
];

export const documentStorageIntegrationsData = [
  {
    name: 'Google Drive',
    icon: googleDriveIcon,
    lastSync: '2 hours ago',
    platform: PLATFORM_CONSTANTS.GOOGLE_DRIVE,
    isConnected: 'not_connected',
    type: 'document-storage',
    description:
      'Connect and store our financial documents directly in Google Drive.',
  },
];

export const arInvoiceIntegrations = [
  {
    name: 'Chargebee',
    icon: chargebeeIcon,
    lastSync: '2 hours ago',
    platform: PLATFORM_CONSTANTS.CHARGEBEE,
    isConnected: 'not_connected',
    description:
      "Chargebee is a cloud-based accounting software that helps you manage your finances, invoices, and expenses. It's easy to use and integrates seamlessly with your business needs.",
  },
  {
    name: 'Stripe',
    icon: stripeIcon,
    lastSync: '2 hours ago',
    platform: 'STRIPE',
    isConnected: 'not_connected',
    description:
      "Stripe is a cloud-based accounting software that helps you manage your finances, invoices, and expenses. It's easy to use and integrates seamlessly with your business needs.",
  },
  {
    name: 'Orb',
    icon: orbIcon,
    lastSync: '2 hours ago',
    platform: 'ORB',
    isConnected: 'not_connected',
    description:
      "Orb is a cloud-based accounting software that helps you manage your finances, invoices, and expenses. It's easy to use and integrates seamlessly with your business needs.",
  },
  {
    name: 'Metronome',
    icon: metronomeIcon,
    lastSync: '2 hours ago',
    platform: 'METRONOME',
    isConnected: 'not_connected',
    description:
      "Metronome is a cloud-based accounting software that helps you manage your finances, invoices, and expenses. It's easy to use and integrates seamlessly with your business needs.",
  },
  {
    name: 'Maxio',
    icon: maxioIcon,
    lastSync: '2 hours ago',
    platform: 'MAXIO',
    isConnected: 'not_connected',
    description:
      "Maxio is a cloud-based accounting software that helps you manage your finances, invoices, and expenses. It's easy to use and integrates seamlessly with your business needs.",
  },
];

export const payrollHRIntegrations = [
  {
    name: 'Gusto',
    icon: gustoIcon,
    lastSync: '2 hours ago',
    platform: 'GUSTO',
    isConnected: 'not_connected',
    description:
      "Gusto is a cloud-based accounting software that helps you manage your finances, invoices, and expenses. It's easy to use and integrates seamlessly with your business needs.",
  },
  {
    name: 'Rippling',
    icon: ripplingIcon,
    lastSync: '2 hours ago',
    isConnected: 'not_connected',
    description:
      "Rippling is a cloud-based accounting software that helps you manage your finances, invoices, and expenses. It's easy to use and integrates seamlessly with your business needs.",
    platform: 'RIPPING',
  },
  {
    name: 'ADP',
    icon: adpIcon,
    lastSync: '2 hours ago',
    isConnected: 'not_connected',
    platform: 'ADP',
    description:
      "ADP is a cloud-based accounting software that helps you manage your finances, invoices, and expenses. It's easy to use and integrates seamlessly with your business needs.",
  },
  {
    name: 'Insperity',
    icon: insperityIcon,
    lastSync: '2 hours ago',
    isConnected: 'not_connected',
    description:
      "Insperity is a cloud-based accounting software that helps you manage your finances, invoices, and expenses. It's easy to use and integrates seamlessly with your business needs.",
    platform: 'INSERPITY',
  },
];

export const crmIntegrations = [
  {
    name: 'Salesforce',
    icon: salesforceIcon,
    lastSync: '2 hours ago',
    isConnected: 'not_connected',
    description:
      "Salesforce is a cloud-based CRM software that helps you manage your finances, invoices, and expenses. It's easy to use and integrates seamlessly with your business needs.",
    platform: 'SALESFORCE',
  },
  {
    name: 'Hubspot',
    icon: hubspotIcon,
    lastSync: '2 hours ago',
    platform: 'HUBSPOT',
    isConnected: 'not_connected',
    description:
      'HubSpot is an AI-powered customer platform that integrates marketing, sales, and customer service tools to help businesses grow by focusing on their customers.',
  },
  // {
  //   name: "CRM",
  //   icon: "/icons/brands/crm.svg",
  //   lastSync: "2 hours ago",
  //   isConnected: false,
  // },
  // {
  //   name: "Tax",
  //   icon: "/icons/brands/tax.svg",
  //   lastSync: "2 hours ago",
  //   isConnected: false,
  // },
];

export const taxIntegrations = [
  {
    name: 'Avalara',
    icon: avalaraIcon,
    lastSync: '2 hours ago',
    isConnected: 'not_connected',
    description:
      "Avalara is a cloud-based tax management software that helps you manage your finances, invoices, and expenses. It's easy to use and integrates seamlessly with your business needs.",
    platform: 'AVALARA',
  },
  {
    name: 'Anrok',
    icon: anrokIcon,
    lastSync: '2 hours ago',
    isConnected: 'not_connected',
    description:
      "Anrok is a cloud-based tax management software that helps you manage your finances, invoices, and expenses. It's easy to use and integrates seamlessly with your business needs.",
    platform: 'ANROK',
  },
];

export const brandImages = {
  QUICKBOOKS: quickbooksIcon,
  QUICKBOOKS_RUTTER: quickbooksIcon,
  QUICKBOOKS_FIVETRAN: quickbooksIcon,
  NETSUITE: netsuiteIcon,
  NETSUITE_RUTTER: netsuiteIcon,
  NETSUITE_FIVETRAN: netsuiteIcon,
  NETSUITE_SUITEANALYTICS_FIVETRAN: netsuiteIcon,
  SAGE_INTACCT: sageIntacctIcon,
  SAGE_INTACCT_RUTTER: sageIntacctIcon,
  ZOHOBOOKS: zohobooksIcon,
  GOOGLE_DRIVE: googleDriveIcon,

  // Billing platforms
  CHARGEBEE: chargebeeIcon,

  // Banking
  PLAID: plaidIcon,

  // Other platforms
  MAXIMOR: maximorIcon,
} as const;

export const financialInstitutionIntegrationsData = [
  {
    name: 'Plaid',
    platform: 'PLAID',
    type: 'financial-institution',
    description: 'Connect your bank accounts for financial data access.',
    icon: plaidIcon,
  },
];

// demo connections for demo integrations (behind feature flag)
export const demoConnectionsData = [
  {
    access_token: 'demo_token_1',
    connection_name: 'SevenRooms - Main',
    entity_id: 'demo_entity_1',
    entity_name: 'Demo Entity',
    organisation_id: 'demo_org',
    platform: 'SEVENROOMS',
    rutter_connection_id: 'demo_conn_1',
    status: true,
    user_email: 'demo@example.com',
    user_id: 'demo_user',
    user_name: 'Demo User',
  },
  {
    access_token: 'demo_token_2',
    connection_name: 'SevenRooms - Downtown',
    entity_id: 'demo_entity_2',
    entity_name: 'Demo Entity 2',
    organisation_id: 'demo_org',
    platform: 'SEVENROOMS',
    rutter_connection_id: 'demo_conn_2',
    status: true,
    user_email: 'demo@example.com',
    user_id: 'demo_user',
    user_name: 'Demo User',
  },
  {
    access_token: 'demo_token_3',
    connection_name: 'SevenRooms - Uptown',
    entity_id: 'demo_entity_3',
    entity_name: 'Demo Entity 3',
    organisation_id: 'demo_org',
    platform: 'SEVENROOMS',
    rutter_connection_id: 'demo_conn_3',
    status: true,
    user_email: 'demo@example.com',
    user_id: 'demo_user',
    user_name: 'Demo User',
  },
  {
    access_token: 'demo_token_4',
    connection_name: 'SevenRooms - West Side',
    entity_id: 'demo_entity_4',
    entity_name: 'Demo Entity 4',
    organisation_id: 'demo_org',
    platform: 'SEVENROOMS',
    rutter_connection_id: 'demo_conn_4',
    status: true,
    user_email: 'demo@example.com',
    user_id: 'demo_user',
    user_name: 'Demo User',
  },
  {
    access_token: 'demo_token_5',
    connection_name: 'SevenRooms - East Side',
    entity_id: 'demo_entity_5',
    entity_name: 'Demo Entity 5',
    organisation_id: 'demo_org',
    platform: 'SEVENROOMS',
    rutter_connection_id: 'demo_conn_5',
    status: true,
    user_email: 'demo@example.com',
    user_id: 'demo_user',
    user_name: 'Demo User',
  },
];

// demo integrations for demo purposes (behind feature flag)
export const demoAccountingIntegrationsData = [
  {
    name: 'SevenRooms',
    icon: sevenRoomsIcon,
    lastSync: '1 hour ago',
    platform: 'SEVENROOMS',
    isConnected: 'connected',
    type: 'accounting',
    description:
      'Restaurant reservation and guest experience management platform.',
  },
  {
    name: 'Fourth',
    icon: fourthIcon,
    lastSync: '2 hours ago',
    platform: 'FOURTH',
    isConnected: 'connected',
    type: 'accounting',
    description:
      'Workforce scheduling and inventory management for hospitality.',
  },
  {
    name: 'Micros (Oracle)',
    icon: microsIcon,
    lastSync: '1 hour ago',
    platform: 'MICROS_ORACLE',
    isConnected: 'connected',
    type: 'accounting',
    description: 'Point-of-sale system for restaurants and hotels.',
  },
  {
    name: 'ADP',
    icon: adpIcon,
    lastSync: '3 hours ago',
    platform: 'ADP',
    isConnected: 'connected',
    type: 'accounting',
    description: 'Payroll processing and human resources management software.',
  },
  {
    name: 'Open Table',
    icon: openTableIcon,
    lastSync: '1 hour ago',
    platform: 'OPENTABLE',
    isConnected: 'connected',
    type: 'accounting',
    description:
      'Restaurant reservation and guest experience management platform.',
  },
  {
    name: 'Agilysys',
    icon: agilysysIcon,
    lastSync: '1 hour ago',
    platform: 'AGILYSYS',
    isConnected: 'connected',
    type: 'accounting',
    description: 'Property and inventory management for hospitality.',
  },
  {
    name: 'Iplicit',
    icon: iplicitIcon,
    lastSync: '1 hour ago',
    platform: 'IPLICIT',
    isConnected: 'connected',
    type: 'accounting',
    description:
      'Accounting and financial management for mid-market organisations.',
  },
];
